/** @format */
import {useEffect} from 'react';

import * as R from 'ramda';
import Alert from '@mui/material/Alert';
import {Box, Grid, LinearProgress, Typography} from '@mui/material';
import {Trans} from 'react-i18next';
import {useNavigate, useLocation} from 'react-router-dom';
import {makeStyles} from '@mui/styles';
import AddCircleOutlineRounded from '@mui/icons-material/AddCircleOutlineRounded';

import {useCallbackOnReturn} from 'helpers/routerHelpers';

import Breadcrumbs from 'components/Breadcrumbs';
import PrimaryMediumButton from 'components/buttons/PrimaryMediumButton';

import Row from './Row';
import {useGetCurrentUserListQuery} from '../graphql/__generated__';

const useStyles = makeStyles(theme => ({
  headerTitle: {
    color: '#F1F1F1',
    fontSize: '28px',
    fontWeight: 700,
    lineHeight: 'normal',
  },
  addSpecialistButton: {
    color: '#F1F1F1',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 'normal',
    [theme.breakpoints.down('md')]: {
      marginTop: '16px',
    },
  },
}));

const breadcrumbs = [
  {
    href: '/home/settings',
    title: <Trans>Настройки</Trans>,
  },
  {
    href: '',
    title: <Trans>Уведомления</Trans>,
  },
];

export type Specialist = {
  id: string;
  name: string;
};

export const SpecialistList = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const classes = useStyles();

  const {loading, error, data, refetch} = useGetCurrentUserListQuery();

  useEffect(() => {
    if (!data?.currentUser?.parentUser) return;

    const specialistId = data.currentUser.specialists[0].id;
    navigate(
      {
        pathname: '/home/settings/notifications',
        search: `?specialistId=${specialistId}&hideInfo=1`,
      },
      {replace: true},
    );
  }, [data, navigate]);

  useCallbackOnReturn(refetch);

  if (error) {
    return <Alert severity='error'>{error.message}</Alert>;
  }
  if (loading || !data?.currentUser) {
    return <LinearProgress style={{flex: 1}} />;
  }

  const {specialists} = data.currentUser;
  const sortedSpecialists = R.sortBy(R.prop('name'), specialists);

  const handleCreate = () => {
    navigate('/home/settings/specialist', {
      state: {background: location},
    });
  };

  return (
    <>
      <Box mb={10}>
        <Breadcrumbs items={breadcrumbs} />
      </Box>

      <Box display='flex' alignItems={'center'} justifyContent={'space-between'} flexWrap={'wrap'}>
        <Typography className={classes.headerTitle}>
          <Trans>Настройка уведомлений</Trans>
        </Typography>

        <PrimaryMediumButton className={classes.addSpecialistButton} onClick={handleCreate}>
          <Box mr={2} display='flex' alignItems='center'>
            <AddCircleOutlineRounded fontSize='small' />
          </Box>
          <Trans>Добавить специалиста</Trans>
        </PrimaryMediumButton>
      </Box>

      <Box mt={6}>
        <Grid container spacing={3}>
          {sortedSpecialists.map((v, i) => (
            <Grid key={i} item xs={12}>
              <Row specialist={v} />
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};
